import NavItem, { INavItemProps } from 'components/atoms/NavItem'
import React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'

interface IProps {
  navItemArray: INavItemProps[]
  dashboard?: boolean
}

const NavItems: React.FC<IProps> = props => {
  return (
    <NavItemsWrapper dashboard={props.dashboard}>
      {props.navItemArray.map((item, index) => (
        <NavItem key={`sidebar-nav-${index}`} {...item} />
      ))}
    </NavItemsWrapper>
  )
}

const NavItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 280px;
  padding: ${({ dashboard }) => (dashboard ? '0 40px 16px 4px' : '40px 40px 16px 4px')};

  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    width: auto;
    gap: 8px;
    padding: 60px 40px 16px 0;
    ${props =>
      props.dashboard
        ? `
      width: 220px;
      padding: 16px 0;
    `
        : `
      flex-direction: row;
      width: 100%;
      height: inherit;
      overflow: auto;
      padding: 0 16px;

    `}
  }
`

export default NavItems
